export function opcoesUsuario(usuarios) {
    return usuarios.map((p) => ({
        id: p.id,
        descricao: p.descricao || p.nomePrincipal || '',
        label: `Usuário: ${p.pessoaUsuario?.usuario || '—'} | CPF: ${p.CPForCNPJ || '—'}`,
    }));
}
const chave = (operadorId, empresaId) => `permissoes.ultimoUsuario:${operadorId}:${empresaId}`;
export function lembrarUsuario(operadorId, empresaId, pessoaId) {
    if (!operadorId || !empresaId || !pessoaId) return;
    try {
        sessionStorage.setItem(chave(operadorId, empresaId), String(pessoaId));
    } catch {}
}
export function recuperarUsuario(operadorId, empresaId, opcoes) {
    if (!operadorId || !empresaId) return null;
    try {
        const id = sessionStorage.getItem(chave(operadorId, empresaId));
        return opcoes.find((p) => String(p.id) === id) || null;
    } catch {
        return null;
    }
}
